import { render, staticRenderFns } from "./Box1.vue?vue&type=template&id=d35f09a6&scoped=true&"
import script from "./Box1.vue?vue&type=script&lang=js&"
export * from "./Box1.vue?vue&type=script&lang=js&"
import style0 from "./Box1.vue?vue&type=style&index=0&id=d35f09a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35f09a6",
  null
  
)

export default component.exports